(function () {
  var BODY_LINES = 5.5;

  function computeCollapsedHeight(el) {
    var cs = getComputedStyle(el);
    var lineHeight = parseFloat(cs.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) lineHeight = parseFloat(cs.fontSize) * 1.4;

    var heading = el.querySelector(':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6');
    var headingExtra = 0;
    if (heading) {
      var hCs = getComputedStyle(heading);
      headingExtra = heading.offsetHeight + parseFloat(hCs.marginTop || 0) + parseFloat(hCs.marginBottom || 0);
    }

    return Math.round(headingExtra + lineHeight * BODY_LINES);
  }

  function initDesc(el, idx) {
    if (el.dataset.zjDescInit) return;
    el.dataset.zjDescInit = '1';

    var collapsedHeight = computeCollapsedHeight(el);
    var full = el.scrollHeight;
    if (full <= collapsedHeight + 16) return;

    if (!el.id) el.id = 'zj-desc-' + idx;

    el.classList.add('zj-desc-clamped');
    el.style.maxHeight = collapsedHeight + 'px';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zj-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', el.id);
    btn.textContent = 'Read More';
    btn.style.marginLeft = getComputedStyle(el).marginLeft;
    el.insertAdjacentElement('afterend', btn);

    el.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height' && el.classList.contains('zj-desc-expanded')) {
        el.style.maxHeight = 'none';
      }
    });

    btn.addEventListener('click', function () {
      var expanded = el.classList.contains('zj-desc-expanded');
      if (expanded) {
        el.style.maxHeight = el.scrollHeight + 'px';
        el.offsetHeight;
        el.style.maxHeight = collapsedHeight + 'px';
        el.classList.remove('zj-desc-expanded');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = 'Read More';
      } else {
        el.classList.add('zj-desc-expanded');
        el.style.maxHeight = el.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = 'Read Less';
      }
    });
  }

  document.querySelectorAll('.zj-product-page .zj-product-page__description').forEach(function (el, idx) {
    if (el.offsetWidth > 0 || el.getClientRects().length) {
      initDesc(el, idx);
      return;
    }
    if (typeof ResizeObserver === 'undefined') return;
    var ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var rect = entries[i].contentRect;
        if (rect.width > 0 || rect.height > 0) {
          initDesc(el, idx);
          ro.disconnect();
          break;
        }
      }
    });
    ro.observe(el);
  });

  var strip = document.querySelector('.zj-product-page .zj-product-page__features');
  if (strip) {
    var applyBleed = function () {
      if (window.innerWidth < 990) {
        strip.style.width = '';
        strip.style.marginLeft = '';
        strip.style.visibility = '';
        return;
      }

      var gallery = document.querySelector('.zj-product-page .product__media-wrapper');
      if (!gallery) {
        strip.style.width = '';
        strip.style.marginLeft = '';
        strip.style.visibility = '';
        return;
      }

      strip.style.width = '';
      strip.style.marginLeft = '';
      var galleryRight = gallery.getBoundingClientRect().right;
      var stripLeft = strip.getBoundingClientRect().left;
      var viewportRight = document.documentElement.clientWidth;
      strip.style.marginLeft = galleryRight - stripLeft + 'px';
      strip.style.width = Math.max(0, viewportRight - galleryRight) + 'px';
      strip.style.visibility = 'visible';
    };

    var resizeFrame;
    var scheduleBleed = function () {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = null;
        applyBleed();
      });
    };

    applyBleed();
    window.addEventListener('resize', scheduleBleed, { passive: true });
  }
})();
